export default "__VITE_ASSET__CcH7Tuft__"